import { createSlice } from '@reduxjs/toolkit';

import {
  alternarStatusModeloNotificacao,
  atualizarModeloNotificacao,
  buscarModeloNotificacao,
  criarModeloNotificacao,
  listarModelosNotificacao,
} from './actions';
import type { ModeloNotificacao, ModelosNotificacaoState } from '../types/modeloNotificacaoTypes';

const initialState: ModelosNotificacaoState = {
  modelos: [],
  isLoading: false,
  isSaving: false,
  error: null,
};

const upsert = (state: ModelosNotificacaoState, modelo: ModeloNotificacao) => {
  const index = state.modelos.findIndex((item) => item.id === modelo.id);
  if (index !== -1) {
    state.modelos[index] = modelo;
  } else {
    state.modelos.push(modelo);
  }
};

const modelosNotificacaoSlice = createSlice({
  name: 'modelosNotificacao',
  initialState,
  reducers: {
    clearModelosNotificacaoError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarModelosNotificacao.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarModelosNotificacao.fulfilled, (state, action) => {
        state.isLoading = false;
        state.modelos = action.payload;
      })
      .addCase(listarModelosNotificacao.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload ?? 'Erro ao carregar os modelos.';
      })
      .addCase(buscarModeloNotificacao.fulfilled, (state, action) => {
        upsert(state, action.payload);
      })
      .addCase(buscarModeloNotificacao.rejected, (state, action) => {
        state.error = action.payload ?? 'Erro ao carregar o modelo.';
      })
      .addCase(criarModeloNotificacao.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(criarModeloNotificacao.fulfilled, (state, action) => {
        state.isSaving = false;
        upsert(state, action.payload);
      })
      .addCase(criarModeloNotificacao.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload ?? 'Erro ao criar o modelo.';
      })
      .addCase(atualizarModeloNotificacao.pending, (state) => {
        state.isSaving = true;
        state.error = null;
      })
      .addCase(atualizarModeloNotificacao.fulfilled, (state, action) => {
        state.isSaving = false;
        upsert(state, action.payload);
      })
      .addCase(atualizarModeloNotificacao.rejected, (state, action) => {
        state.isSaving = false;
        state.error = action.payload ?? 'Erro ao salvar o modelo.';
      })
      .addCase(alternarStatusModeloNotificacao.fulfilled, (state, action) => {
        upsert(state, action.payload);
      })
      .addCase(alternarStatusModeloNotificacao.rejected, (state, action) => {
        state.error = action.payload ?? 'Erro ao atualizar o status.';
      });
  },
});

export const { clearModelosNotificacaoError } = modelosNotificacaoSlice.actions;

export default modelosNotificacaoSlice.reducer;
